import { mutator } from 'satcheljs';
import {
    setHasAttachmentTriggerWords,
    setAttachmentKeywordsDetectedBeforeUserInput,
} from '../actions/internalActions';

mutator(setHasAttachmentTriggerWords, actionMessage => {
    const { pluginViewState, hasTriggerWords } = actionMessage;

    pluginViewState.hasAttachmentTriggerWords = hasTriggerWords;
});

mutator(setAttachmentKeywordsDetectedBeforeUserInput, actionMessage => {
    const { pluginViewState, count } = actionMessage;
    pluginViewState.attachmentKeywordsDetectedBeforeUserInput = count;
});
